import { useMemo } from 'react';
import cx from 'classnames';
import { compact } from 'lodash';

import { IconSettings24 } from 'src/assets/icons/24x24/IconSettings24';
import { ContextMenu } from 'src/components/ContextMenu';
import { CUSTOM_ICON_BUTTON_SIZE, CustomIconButton } from 'src/components/CustomIconButton';
import { CustomTypography } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

export const ActionsMenu = ({
  className,
  onReauthorizeClick,
  onRemoveClick,
  disabled,
  displayReAuth,
}) => {
  const styles = useStyles();

  const contextMenuItems = useMemo(
    () =>
      compact([
        displayReAuth
          ? {
              id: 'reauthorizeIntegration',
              label: 'Re-authorize integration',
              onClick: onReauthorizeClick,
              disabled,
            }
          : null,
        {
          id: 'removeIntegration',
          label: (
            <CustomTypography className={styles.removeIntegrationLabel}>
              Remove integration
            </CustomTypography>
          ),
          onClick: onRemoveClick,
          disabled,
        },
      ]),
    [onReauthorizeClick, disabled, styles, onRemoveClick, displayReAuth]
  );

  return (
    <ContextMenu
      className={cx(styles.root, className)}
      items={contextMenuItems}
      disabled={disabled}
      renderButton={(props) => (
        <CustomIconButton
          size={CUSTOM_ICON_BUTTON_SIZE.large}
          data-testid="SettingsButton"
          {...props}
        >
          <IconSettings24 />
        </CustomIconButton>
      )}
      menuProps={{
        'data-testid': 'SettingsMenu',
      }}
    />
  );
};
